import { useEffect, useState } from 'react';
import {addZero} from 'bodycodi/cmap/app/js/common';

export type TimerProp = {
    setEnd?: Function;
    refresh?: number;
    stop?: boolean;
}

export type TimerSetting = {
    end: boolean;
    refresh: number;
    stop: boolean;
}

const Timer = ({setEnd = () => {}, refresh, stop} : TimerProp) => {
    let [time, setTime] = useState<string>("");
    let [remainTime, setRemainTime] = useState<number>(2);//remainTime1 data.remainTime
    let [sec, setSec] = useState<number>(59);//data.remainTime
    let [timer, setTimer] = useState<any>();
    
    useEffect(() => {
        clearInterval(timer);
        setRemainTime(2);
        setSec(59);
        setEnd(false);
    },[refresh]);
    
    useEffect(() => {
        if(stop){
            clearInterval(timer);
        }
    },[stop]);
    
    useEffect(() => {
        let day = Math.floor(remainTime/60/24);
        let hour = Math.floor((remainTime - (day*60*24))/60);
        let min = Math.floor(remainTime - (day*60*24) - (hour*60));
        if(day == 0){
            setTimer(setTimeout(() => {
                countDown();
            }, 1000));
        }else{
            //countDown();
            setTime(`${day}일 ${hour}시간 ${min}분 남음`);
        }
        
        return () => {
            clearTimeout(timer)
        }   
    },[remainTime, sec])
    
    let countDown = () => {
        let day = Math.floor(remainTime/60/24);
        let hour = Math.floor((remainTime - (day*60*24))/60);
        let min = Math.floor(remainTime - (day*60*24) - (hour*60));
        setTime(`${addZero(min)}:${addZero(sec)}`);
        if(remainTime !== 0){
            if(sec == 0){
                setRemainTime(remainTime-1);
                setSec(59);
            }else{
                setSec(sec-1);    
            }
        }else{
            if(sec === 0){
                clearInterval(timer);
                setEnd(true);
            }else{
                setSec(sec-1);
            }
        }
    }
    
    return(
        <span className={"timer"+((remainTime === 0 && sec < 10) ? " red" : "")}>{time}</span>
    )
}

export default Timer;